import { Icon, getTranslatedText } from '@nile/components';
import { Autocomplete, TextField } from '@superops/ui-design-system';
import { Search } from '@styled-icons/boxicons-regular/Search';
import { debounce } from 'lodash';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

function AutoCompleteSearchInput(props) {
  const { intl, noMargin = false, clearButton = true } = props;
  const deselectedOptions = [];
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState(deselectedOptions);

  const updateText = useCallback((value) => {
    setInputValue(value);
    debouncedSearch(value);
  });

  const debouncedSearch = debounce((value) => {
    if (props.debouncedFilter) props.debouncedFilter(value);
  }, 500); //TODO - give some time limit. check bug.

  // const updateText = useCallback(
  //   (value) => {
  //     setInputValue(value);

  //     if (value === '') {
  //       setOptions(deselectedOptions);
  //       return;
  //     }

  //     const filterRegex = new RegExp(value, 'i');
  //     const resultOptions = deselectedOptions.filter((option) =>
  //       option.label.match(filterRegex),
  //     );
  //     setOptions(resultOptions);
  //   },
  //   [deselectedOptions],
  // );

  // not needed as the implementaion is different
  // const updateSelection = useCallback((selected) => {
  //   const selectedValue = selected.map((selectedItem) => {
  //     const matchedOption = options.find((option) => {
  //       return option.value.match(selectedItem);
  //     });
  //     return matchedOption && matchedOption.label;
  //   });

  //   setSelectedOptions(selected);
  //   setInputValue(selectedValue);
  // }, []);

  const setPortalStyles = () => {
    setTimeout(() => {
      let element = document.getElementById('colsearch');
      let popoverOverlay =
        element?.parentElement?.parentElement?.parentElement?.parentElement
          ?.parentElement;
      if (popoverOverlay) {
        popoverOverlay.style.visibility = 'hidden';
      }
    }, 0);
  };

  return (
    <div className={`mb-20 autoComplete ${!noMargin && 'mt-20'}`}>
      <TextField
        value={inputValue}
        onFocus={setPortalStyles}
        onChange={updateText}
        prefix={<SVGIcon name="Search" />}
        clearButton={clearButton}
        onClearButtonClick={() => {
          updateText('');
        }}
        placeholder={getTranslatedText(intl, 'admin.Technicianrole.pl.search')}
        variant="outline"
      />
    </div>
  );
}

export default injectIntl(AutoCompleteSearchInput);
